import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule } from '@angular/forms'
import { HttpModule } from '@angular/http'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { APP_BASE_HREF, DatePipe, CurrencyPipe } from '@angular/common'

/*
 * Platform and Environment providers/directives/pipes
 */
import { environment } from 'environments/environment'
// App is our top level component
import { AppComponent } from './app.component'
import { APP_RESOLVER_PROVIDERS } from './app.resolver'

// App Components
import { AuthenticatedAppComponent } from './authenticated-app/authenticated-app.component'
import { IntroComponent } from './intro/intro.component'
import { PathResetDialogComponent } from './workspace/path-reset-dialog/path-reset-dialog.component'
import { EnrollmentComponent } from './enrollment'
import { ProfileComponent } from './profile'
import { ClassScheduleComponent } from './class-schedule'
import { PrivateTutoringComponent } from './private-tutoring'
import { EbookResourcesComponent } from './ebook-resources'
import { VideoResourcesComponent } from './video-resources'
import { PdfResourcesComponent } from './pdf-resources'
import { LsacComponent } from './lsac'
import { BrightcoveComponent, VideoPlayerComponent } from './video-players'
import { PlaceholderComponent } from './placeholder'
import { BmdComponent } from './bmd'
import { OgExamsComponent } from './og-exams'
import { QbanksComponent } from './qbanks'
// App Modules
import { AppRoutingModule } from './app-routing.module'
import { MenuItemResolver } from './menu-item.resolver'

import { SharedModule } from './shared'

const SharedModuleForRoot = SharedModule.forRoot()

// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  MenuItemResolver,
  DatePipe,
  CurrencyPipe,
  { provide: APP_BASE_HREF, useValue: BASE_URL }
]

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    AuthenticatedAppComponent,
    IntroComponent,
    PathResetDialogComponent,
    EnrollmentComponent,
    ProfileComponent,
    ClassScheduleComponent,
    PrivateTutoringComponent,
    EbookResourcesComponent,
    VideoResourcesComponent,
    PdfResourcesComponent,
    LsacComponent,
    BrightcoveComponent,
    VideoPlayerComponent,
    PlaceholderComponent,
    BmdComponent,
    OgExamsComponent,
    QbanksComponent
  ],
  /**
   * Import Angular's modules.
   */
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    SharedModuleForRoot

    /**
     * This section will import the `DevModuleModule` only in certain build types.
     * When the module is not imported it will get tree shaked.
     * This is a simple example, a big app should probably implement some logic
     */
    // ...environment.showDevModule ? [ DevModuleModule ] : [],
  ],
  /**
   * Expose our Services and Providers into Angular's dependency injection.
   */
  providers: [environment.ENV_PROVIDERS, APP_PROVIDERS]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts